// extracted by mini-css-extract-plugin
export default {"page":"N8mNu4jokkSl0KC2M8Ay","page_contents":"AVGqJ0cFmE0CMGL93meZ","pageContents":"AVGqJ0cFmE0CMGL93meZ"};